/**
 * Class for handling app extension point
 *
 * @class AppExtensionPoint
 * @depends jquery.js, controller.js
 * @author znsakala
 */
var $ = require('jquery');
var siteadmin = require('../siteadmin');
var api = require('../api');

(function() {
    'use strict';
    var self = this;

    var siteAdminItemClass   = '.ui-siteadmin-webcomponent',
        upSellBehaviourClass = 'ui-behaviour-upsell';

    this.controllerLoaded  = false;
    this.webcomponentInstanceId = null;

    this.afterFillContent = function(el, payload, contentElement) {

        var title       = this.getSiteAdminItem().attr('data-window-title'),
            helpTopic   = this.getSiteAdminItem().attr('data-webcomponent-id');

        api.updateTitle(title);
        api.updateDescr('');
        api.updateButtons({});
        api.updateNavi({});
        api.updateHelpTopic(helpTopic);

        if (payload.success) {
            self.registerWebcomponent(payload.data);
        }

        this.controllerLoaded = true;
    };

    this.getSiteAdminItem = function() {
        return siteadmin.getSidebarContainer().find(siteAdminItemClass);
    };

    this.hasUpsellBehaviour = function() {
        if (this.getSiteAdminItem().hasClass(upSellBehaviourClass)) {
            return true;
        }

        return false;
    };

    this.hide = function()  {
        self.unregisterWebcomponent();
    };

    this.registerWebcomponent = function(data) {
        self.webcomponentInstanceId = data.webcomponentInstanceId;

        diy.editor.app.webcomponentService.registerWebcomponentInstance(
            self.webcomponentInstanceId,
            data.webcomponentData,
            data.proxyUrlPrefix
        );
    };

    this.unregisterWebcomponent = function() {
        diy.editor.app.webcomponentService.unregisterWebcomponentInstance(self.webcomponentInstanceId);
        self.webcomponentInstanceId = null;
    };

    this.show = function () {
        if (this.hasUpsellBehaviour()) {
            siteadmin.destroyController(this.getSiteAdminItem().attr('id'));

            var webComponentId = this.getSiteAdminItem().attr('data-webcomponent-id');
            diy.editor.tariffUpdate.openPopup({
                component: 'webComponentUpSell',
                webComponentId: webComponentId
            });
        }
    };

    return this;

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/main/controllers/appExtensionPoint.js
 ** module id = 841
 ** module chunks = 0
 **/